import Vue from 'vue'
import App from './App.vue'

import Ionic from "@ionic/vue"
import "@ionic/core/css/core.css"
import "@ionic/core/css/ionic.bundle.css"



import {IonicVueRouter} from "@ionic/vue"

import VeeValidate from 'vee-validate';

import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
Vue.use(VueFormWizard);

Vue.config.productionTip = false
Vue.use(Ionic);
Vue.use(IonicVueRouter);
Vue.use(VeeValidate);
//map
import { Icon }  from 'leaflet';
import 'leaflet/dist/leaflet.css';

import axios from 'axios';
import * as store from 'store';

store.set('base_url','https://huvestsoftware.co.za:3002'); //store.set('base_url','https://huvestsoftware.co.za:3002');

Vue.prototype.$http=axios;
Vue.prototype.$store=store;
// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
//end map
const router=new IonicVueRouter({
  routes:[
    {
      path:'/',redirect:'/home'
    },
    {
      path:'/home',
      name:'home',
      component:()=>
        import("@/components/HomePage")
    },
    {
      path:'/contacts',
      name:"contacts",
      component:()=>
        import("@/components/Contacts")
    },
    {
      path:'/covid-contacts',
      name:"covid-contacts",
      component:()=>
        import("@/components/CovidContacts")
    },
    {
      path:'/province-contacts',
      name:"province-contacts",
      component:()=>
        import("@/components/ProvincialContacts")
    },
    {
      path:'/search-contacts',
      props:true,
      name:"search-contacts",
      component:()=>
        import("@/components/SearchContacts")
    },
    {
      path:'/contact-detail',
      props:true,
      name:"contact-detail",
      component:()=>
        import("@/components/ContactDetail")
    },
    {
      path:'/ambulance',
      name:"ambulance",
      component:()=>
        import("@/components/Ambulance")
    },
    {
      path:'/complaints',
      name:"complaints",
      component:()=>
        import("@/components/Complaints")
    },
    {
      path:'/facility',
      name:"facility",
      component:()=>
        import("@/components/Facility")
    },
    {
      path:'/faq',
      name:"faq",
      component:()=>
        import("@/components/FAQ")
    },
    {
      path:'/followup',
      name:"followup",
      component:()=>
        import("@/components/FollowUp")
    },
    {
      path:'/stats',
      name:"stats",
      component:()=>
        import("@/components/Stats")
    },
    {
      path:'/screening',
      name:"screening",
      component:()=>
        import("@/components/SelfScreening")
    },
    {
      path:'/volunteer',
      name:"volunteer",
      component:()=>
        import("@/components/Volunteer")
    }
  ]
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
